import Button from './ui/Button';

const companyLinks = [
  { label: 'About Us', href: '/about' },
  { label: 'Team', href: '/team' },
  { label: 'Careers', href: '/careers' },
  { label: 'FAQ', href: '/faq' },
  { label: 'Contact', href: '/contact' },
];

const servicesLinks = [
  { label: 'Financial Planning', href: '/services#financial-planning' },
  { label: 'Generational Wealth Planning', href: '/services#generational-wealth' },
  { label: 'Estate Planning', href: '/services#estate-planning' },
  { label: 'Retirement Income Planning', href: '/services#retirement-income-planning' },
  { label: 'Tax Planning', href: '/services#tax-planning' },
  { label: 'Alternative Investments', href: '/services#alternative-investments' },
];

const followLinks = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/carter-asset-management', external: true },
  { label: 'YouTube', href: 'https://www.youtube.com/@carterassetmanagement', external: true },
  { label: 'Instagram', href: 'https://www.instagram.com/', external: true },
  { label: 'Spotify', href: 'https://open.spotify.com/', external: true },
];

function FooterLinkColumn({ title, links }) {
  return (
    <div className="lg:col-span-2">
      <h4 className="text-xs/5 font-semibold uppercase tracking-wide text-white/80">{title}</h4>
      <ul className="mt-3 space-y-2 text-sm/6 text-white/85">
        {links.map((link) => (
          <li key={link.label}>
            <a
              className="transition-colors hover:text-white hover:underline"
              href={link.href}
              {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="bg-cam-blue text-white">
      {/* TOP GRID */}
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-12 lg:gap-x-12 lg:gap-y-10">
          {/* Brand / About */}
          <div className="md:col-span-2 lg:col-span-6">
            <div className="inline-flex items-center rounded-lg bg-white/10 px-3 py-2 ring-1 ring-white/15">
              <span className="text-sm font-semibold tracking-tight">Carter Asset Management</span>
            </div>
            <p className="mt-4 text-sm/6 text-white/85">
              Independent fiduciary aligning capital with conviction through planning,
              disciplined investing, and proactive tax strategy.
            </p>

            <div className="mt-5 space-y-2 text-sm/6 text-white/85">
              <p>123 Main St, Tampa, FL 336XX</p>
              <p>(813) 555-0123</p>
              <p>
                <a className="underline" href="mailto:hello@carteram.com">
                  hello@carteram.com
                </a>
              </p>
            </div>

            <div className="mt-5">
              <Button
                href="https://employee.carteram.com"
                target="_blank"
                rel="noopener noreferrer"
                variant="secondary"
              >
                Employee Login
              </Button>
            </div>
          </div>

          <FooterLinkColumn title="Company" links={companyLinks} />
          <FooterLinkColumn title="Services" links={servicesLinks} />
          <FooterLinkColumn title="Follow Us" links={followLinks} />
        </div>
      </div>

      {/* DIVIDER */}
      <hr className="mx-auto max-w-6xl border-white/15" />

      {/* DISCLAIMER ROW */}
      <div className="mx-auto max-w-6xl px-4 py-6 md:px-6">
        <p className="text-xs/5 text-white/80">
          The content is developed from sources believed to be providing accurate information. The information in this material
          is not intended as tax or legal advice. Please consult legal or tax professionals for specific information regarding
          your individual situation.
        </p>
      </div>

      {/* BOTTOM BAR */}
      <div className="bg-black/10">
        <div className="mx-auto max-w-6xl px-4 py-4 flex flex-col items-start justify-between gap-3 md:flex-row md:items-center md:px-6">
          <p className="text-xs/5 text-white/70">
            © {new Date().getFullYear()} Carter Asset Management. All rights reserved. Investment advisory services offered through
            Carter Asset Management, LLC, a Registered Investment Adviser. Registration does not imply a certain level of skill or
            training.
          </p>
          <p className="text-xs/5 text-white/80">
            123 Main St, Tampa, FL 336XX · (813) 555-0123 ·{' '}
            <a className="underline" href="mailto:hello@carteram.com">
              hello@carteram.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
